import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type State = {
  checked?: boolean
}

const radioContainerCheckedCss = ({ checked }: State) =>
  checked &&
  css`
    color: ${themeGet('colors.primary.main')};
    cursor: default;

    &:hover {
      p {
        color: ${themeGet('colors.primary.main')};
      }
    }
  `

export const RadioContainer = styled.label<State>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;
  font-size: 14px;
  font-weight: ${themeGet('fontWeights.1')};
  letter-spacing: -0.2px;
  cursor: pointer;
  color: ${themeGet('colors.text.primary')};
  user-select: none;

  &:hover {
    p {
      color: ${themeGet('colors.primary.dark')};
    }
  }

  ${radioContainerCheckedCss}
`

export const HiddenRadio = styled.input`
  display: none;
`

const styledRadioCheckedCss = ({ checked }: State) =>
  checked &&
  css`
    border: 2px solid ${themeGet('colors.primary.main')};
    background-color: ${themeGet('colors.transparent')};

    > div {
      opacity: 1;
    }
  `

export const StyledRadio = styled.div<State>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${themeGet('colors.line.primary')};
  background-color: ${themeGet('colors.background.paperElevation2')};
  transition: all ${themeGet('colors.defaultTransitionTime')} ease-in-out;

  ${styledRadioCheckedCss}
`

export const RadioPoint = styled.div`
  opacity: 0;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${themeGet('colors.primary.main')};
  transition: opacity ${themeGet('colors.defaultTransitionTime')} ease-in-out;
`
